import React from 'react'

import Filesystem from '../lib/FilesystemWeb'
import { logError } from './LogHelper'

export default class FileHelper{

  constructor(){  
    this.fs = new Filesystem()
  }

  init(){
    return new Promise((resolve,reject) => {
      this.fs.init()
      .then((ret) => {
        resolve()
        console.log('FSLOG',ret)
      })
      .catch(err => reject(err))
    })
  }

  getAvailableSpace(){
    return new Promise((resolve,reject)=>{
      this.fs.getAvailableSpace()
        .then((used,left)=>{
          resolve(used,left)
        },(error)=>{
          reject(error)
        })
    })
  }

  writeTrack(dir,filename,data,blnReplace){
    return new Promise((resolve,reject)=>{
      const abv = new Uint8Array(data)
      const blob = new Blob([abv], {type: 'audio/mpeg'})
      this.fs.writeFile(dir,filename.toString(),blob,blnReplace)
        .then((result)=>{
          resolve(result);
        },(error)=>{
          reject(error);
        });
    })
  }

  writeJSON(dir,filename,data,blnReplace){
    return new Promise((resolve,reject)=>{
      const json = JSON.stringify(data)
      const blob = new Blob([json], {type: 'text/plain'})
      this.fs.writeFile(dir,filename.toString(),blob,blnReplace)
        .then((result) => {
          resolve(result)
        },(error) => {
          reject(error)
        })
    })
  }

  readJSON(dir,filename){
    return new Promise((resolve,reject)=>{
      this.fs.readAsText(dir,filename)
        .then((result) => {
          resolve(JSON.parse(result))
        },(error) => {
          reject(error)
        })
    })
  }

  checkFile(dir,filename){
    return new Promise((resolve,reject)=>{
      this.fs.checkFile(dir,filename)
        .then((result) => {
          resolve(result)
        },(error) => {
          reject(error)
        })
    })
  }

  readTrack(dir,filename){
    return new Promise((resolve,reject)=>{
      this.fs.readAsArrayBuffer(dir,filename.toString())
        .then(function(result){
          const abv = new Uint8Array(result)
          const blob = new Blob([(abv)], {type: 'audio/mpeg'})
          resolve(blob)
        },function(error){
          reject(error)
        })
    })
  }
  
  readTrackArrBuffer(dir,filename){
    return new Promise((resolve,reject)=>{
      this.fs.readAsArrayBuffer(dir,filename.toString())
        .then(function(result){
          resolve(result)
        },function(error){
          reject(error)
        })
    })
  }

  readDirectory(dir){
    return new Promise((resolve,reject)=>{
      this.fs.readDirectory(dir)
        .then((results)=>{
          resolve(results)
        },(error)=>{
          reject(error)
        })
    })
  }

  deleteFile(path,file){
    
    return new Promise((resolve,reject)=>{
      this.fs.deleteFile(path,file)
        .then((results) => {
          resolve(results)
        },(error) => {
          reject(error)
        });
    })
  }

  getMetadata(path,file){
    return new Promise((resolve,reject)=>{
      this.fs.getMetadata(path,file)
        .then((results) => {
          resolve(results)
        },(error) => {
          reject(error)
        })
    })
  }

  formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return '0 Bytes';

    var k = 1024;
    var dm = decimals < 0 ? 0 : decimals;
    var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    var i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
	}
}


// WEBPACK FOOTER //
// ./src/helpers/FileHelperWeb.js